import template from './NewsletterFormField.html';

export default {
  name: 'NewsletterFormField',

  template,

  props: {
    initContent: {
      type: Object,
      required: true,
    },
    uniqueId: String,
  },

  data() {
    return {
      content: this.initContent,
    };
  },

  created() {
    this.validateContent(this.content);
  },

  methods: {
    validateContent(content) {
      if (typeof content.newsletter_form.title === 'undefined' || typeof content.newsletter_form.mailTo === 'undefined' || typeof content.newsletter_form.content === 'undefined') {
        throw new Error('Invalid content given to NewsletterFormField');
      }

      return true;
    },

  },
};
